import { render, staticRenderFns } from "./TradeLogCard.vue?vue&type=template&id=21b8de94&"
import script from "./TradeLogCard.vue?vue&type=script&lang=js&"
export * from "./TradeLogCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports